


















import { Vue, Component, Watch } from 'vue-property-decorator'
import ApplyHeader from '@/components/apply/ApplyHeader.vue'
import { namespace } from 'vuex-class'
import Loader from '@/components/Loader.vue'
import API from '@/services/API'
import { Member } from '@/types/Member.type'
import { ApplyStep } from '@/utils/ApplyAttr'
import RouteName from '@/utils/RouteName'

const apply = namespace('apply')
const user = namespace('user')

@Component({
    components: { Loader, ApplyHeader },
})
export default class CommunityApplyLayout extends Vue {
    @user.State me!: Member
    @apply.Getter flow!: string
    @apply.Getter layout!: string

    @Watch('step')
    onStepChanged() {
        this.forceRefresh()
    }

    loading = true
    refresh = false

    mounted() {
        this.fetchFlow()
    }

    get step() {
        return this.$route.meta.step
    }

    get asideComponent() {
        this.refresh = !this.refresh
        return async () => {
            try {
                return await import(`@/components/apply/steps/${this.layout}/${this.step}/${this.flow}/Aside.vue`)
            } catch (e) {
                return await import(`@/components/apply/steps/${this.layout}/${this.step}/default/Aside.vue`)
            }
        }
    }

    forceRefresh() {
        this.refresh = !this.refresh
    }

    async fetchFlow() {
        try {
            const flow = await API.applyFlow(this.$route.query?.planId as string)
            this.$store.commit('apply/SET_FLOW', flow.data)
            if (this.step !== flow.data.apply?.step) {
                await this.redirectToStep(flow.data.apply?.step)
            }
        } catch (e) {
            const code = e && e.response && e.response.status
            if (code === 409) {
                return (window.location.href = '/')
            }
        } finally {
            this.loading = false
        }
    }

    async redirectToStep(flowStep?: string) {
        // if no flowStep and current step is PROFILE --> its ok
        if (this.step === ApplyStep.PROFILE && !flowStep) {
            return null
        }

        switch (flowStep) {
            case ApplyStep.MEMBERSHIP:
                return await this.$router.push({ ...this.$route, name: RouteName.COMMUNITY_APPLY_MEMBERSHIP })
            case ApplyStep.VALIDATION:
                return await this.$router.push({ ...this.$route, name: RouteName.COMMUNITY_APPLY_VALIDATION })
            case ApplyStep.PAYMENT:
                return await this.$router.push({ ...this.$route, name: RouteName.COMMUNITY_APPLY_PAYMENT })
            case 'confirmation':
            case ApplyStep.FINISHED:
                return await this.$router.push({ ...this.$route, name: RouteName.COMMUNITY_APPLY_FINISHED })
            default:
                return await this.$router.push({ ...this.$route, name: RouteName.COMMUNITY_APPLY })
        }
    }
}
